export const loginCodeGuideMarkdown = `
# Sign In with a Login Code

Use **Send A Login Code** when you want to sign in without typing your password. VetNebula will email you a one-time code you enter on the website.

---

## 1. Request a login code

1. Go to the VetNebula sign-in page.
2. Click **Send A Login Code** (blue button below **Sign In**).

![Sign-in page with Send A Login Code button](/images/guides/login-code/00-sign-in.png)

---

## 2. Enter your email

1. Enter the email address linked to your VetNebula account.
2. Click **Submit**.

![Enter your email to receive a login code](/images/guides/login-code/01-email.png)

You should see a confirmation that a code was sent to your email.

---

## 3. Check your email

Look for an email from VetNebula with your **single-use login code**.

- Check your **inbox** and **spam/junk** folder.
- The code is valid for a limited time — use it soon after you receive it.

---

## 4. Enter the code

After you submit your email, the page changes to ask for your code.

1. Type the code from your email into **Single Time Code**.
2. Click **Submit**.

If the code is correct, you are signed in and taken into VetNebula.

**Need a new code?** Click **Request a New Code** to send another email, then enter the latest code you receive.

---

## When to use a login code

- You forgot your password and need quick access (you can reset your password later from your profile).
- You are on a shared or public device and prefer not to type your password.
- You are having trouble with your saved password in the browser.

For a permanent password change, use **Reset Password** on the sign-in page instead.

---

## Troubleshooting

- **Invalid code** — Codes expire and can only be used once. Click **Request a New Code** and enter the newest code from your email.
- **No email** — Wait a few minutes, check spam, and confirm you entered the correct email address (including any \`+coach\` alias if applicable).
- **No account found** — If you were invited but never set up your account, try **Find My Account** instead.
- **Code page did not appear** — Make sure you clicked **Submit** after entering your email. You can also go back to the sign-in page and click **Send A Login Code** again.

---

## Quick reference

1. Sign in page → **Send A Login Code**
2. Enter email → check inbox for code
3. Enter code on the website → signed in
`;
